export default function SDGsCommitment() {
  const sdgs = [
    {
      number: '1',
      title: '貧困をなくそう',
      description: '廃校活用と地域雇用の創出を通じて、農山村地域の経済的自立を支援し、貧困の解消に貢献します。',
      color: 'bg-red-600'
    },
    {
      number: '2',
      title: '飢餓をゼロに',
      description: '循環型陸上養殖システムにより、安定した食料生産を実現し、持続可能な食料供給体制を構築します。',
      color: 'bg-yellow-500'
    },
    {
      number: '3',
      title: 'すべての人に健康と福祉を',
      description: '安全・安心な食品生産と快適な居住環境の整備を通じて、地域住民の健康と福祉の向上を図ります。',
      color: 'bg-green-600'
    },
    {
      number: '4',
      title: '質の高い教育をみんなに',
      description: '廃校施設を学習・研究拠点として再活用し、地域の子どもたちや若者に質の高い教育機会を提供します。',
      color: 'bg-red-700'
    },
    {
      number: '5',
      title: 'ジェンダー平等を実現しよう',
      description: '年齢・性別を問わず多様な人材が活躍できる職場環境をつくり、地域における平等な機会を推進します。',
      color: 'bg-orange-500'
    },
    {
      number: '6',
      title: '安全な水とトイレを世界中に',
      description: '循環型水処理システムの活用により、水資源の効率的な利用と水質保全に取り組みます。',
      color: 'bg-blue-500'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">SDGsへの取り組み</h2>
          <div className="w-20 h-1 bg-teal-600 mx-auto mb-6"></div>
          <p className="text-base text-gray-700 max-w-3xl mx-auto leading-relaxed">
            私たちの事業は、国連が掲げる持続可能な開発目標（SDGs）の達成に貢献します。<br />
            環境保全と地域創生を通じて、より良い未来を実現します。
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {sdgs.map((sdg, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 overflow-hidden"
            >
              <div className={`${sdg.color} text-white p-6 text-center`}>
                <div className="text-4xl font-bold mb-2">目標 {sdg.number}</div>
                <div className="text-lg font-semibold">{sdg.title}</div>
              </div>
              <div className="p-6 text-center">
                <p className="text-sm text-gray-700 leading-relaxed">{sdg.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}